export default {
      id: "icon-agences-usage",
      viewBox: "0 0 32 32",
      url: "../icon/" + "icons.svg#icon-agences-usage",
      toString: function () {
        return this.url;
      }
    }